import script from "./other-tool-list.vue?vue&type=script&setup=true&lang=js"
export * from "./other-tool-list.vue?vue&type=script&setup=true&lang=js"

import "./other-tool-list.vue?vue&type=style&index=0&id=85796768&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85796768"]])

export default __exports__